import { AgGridReact } from 'ag-grid-react';
import { Theme, themeQuartz } from "ag-grid-community";
import React, { useEffect, useMemo, useState } from 'react';
import Loader from '../../../../components/loader';
import { StatusStaticCell, titleCell } from '../../../../components/elements/function';
import { useNavigate, useParams } from 'react-router-dom';
import { useWorkOrderApi } from '../../../../store/api/hooks/workOrderApiHook';
import toast from 'react-hot-toast';
import { showLocalDateTime } from '../../../../_common/functions';
import { URLS } from '../../../../_config';

const WorkOrderHistory: React.FC = () => {
    const myTheme = themeQuartz.withParams({
        headerBackgroundColor: `#F0F0F0`
    });

    const params: any = useParams();
    const [rowData, setrowData] = useState<any>(null);
    const workOrderApi: any = useWorkOrderApi();
    const navigate = useNavigate();

    const theme = useMemo<Theme | "legacy">(() => {
        return myTheme;
    }, []);

    const columnDefs = [
        {
            headerName: 'WO Number',
            field: 'workOrderCode',
            headerClass: 'bg-[#f0f0f0]',
            flex: 1,
            minWidth: 120,
            cellRenderer: (params: any) => (
                <p className="hover:text-primary font-medium cursor-pointer truncate" title={params.value}>
                    {params.value}
                </p>
            ),
            onCellClicked: (param: any) => {
                const url = URLS.WORK_ORDER_DETAILS(param.data.workOrderID);
                window.open(url, '_blank');
            },
        },
        {
            headerName: 'Initial Description',
            field: 'description',
            headerClass: 'bg-[#f0f0f0]',
            flex: 1,
            minWidth: 150,
            cellRenderer: (data: any) => (
                <p className="truncate" title={data.value || '--'}>{data.value || '--'}</p>
            ),
        },
        {
            headerName: 'Reference Request ID',
            field: 'workRequestCode',
            headerClass: 'bg-[#f0f0f0]',
            flex: 1,
            minWidth: 140,
            cellStyle: { textAlign: 'center' },
            cellRenderer: (data: any) => (
                <p className="truncate" title={data.value || '--'}>{data.value || '--'}</p>
            ),
        },
        {
            headerName: 'Actual Start Date and Time',
            field: 'originalStartDate',
            headerClass: 'bg-[#f0f0f0]',
            flex: 1,
            minWidth: 160,
            cellRenderer: (data: any) => (
                <p className="hover:text-primary font-medium cursor-pointer truncate" title={data.value ? showLocalDateTime(data.value) : '--'}>
                    {data.value ? showLocalDateTime(data.value) : '--'}
                </p>
            ),
        },
        {
            headerName: 'Actual End Date and Time',
            field: 'originalEndDate',
            headerClass: 'bg-[#f0f0f0]',
            flex: 1,
            minWidth: 160,
            cellRenderer: (data: any) => (
                <p className="hover:text-primary font-medium cursor-pointer truncate" title={data.value ? showLocalDateTime(data.value) : '--'}>
                    {data.value ? showLocalDateTime(data.value) : '--'}
                </p>
            ),
        },
        {
            headerName: 'Status',
            field: 'woStatusName',
            headerClass: 'bg-[#f0f0f0]',
            flex: 1,
            minWidth: 100,
            cellRenderer: (params: any) => (
                <p className="truncate">{StatusStaticCell(params)}</p>
            ),
        },
    ];

    const GetWorkOrderList = (assetID: any = params.id) => {
        const payload: any = {
            assetIDs: assetID,
            woStatusIDs: '3,5,6',
            sortingBy: 'OriginalEndDate',
            sortingOrder: 'desc',
        };
        setrowData(null);
        workOrderApi.GetWorkOrderList(
            payload,
            (resp: any) => {
                setrowData(resp.workOrderList || []);
            },
            (error: any) => {
                console.log('error =>', error);
                toast.error(error);
            }
        );
    };

    useEffect(() => {
        if (params.id) {
            GetWorkOrderList(params.id);
        }
    }, [params]);

    return (
        <div>
            <div className="flex items-center justify-between h-[60px]">
                <h4 className="font-semibold text-[0.938rem]">Task History</h4>
            </div>
            <div className={`mb-3 ag-theme-alpine overflow-auto ${!rowData || rowData.length === 0 || rowData.length <= 2 ? 'h-[150px]' : 'h-[300px]'}`}>
                <AgGridReact
                    theme={theme}
                    columnDefs={columnDefs}
                    rowData={rowData || []}
                    pagination={false}
                    domLayout="normal"
                    ensureDomOrder={true}
                    suppressHorizontalScroll={false}
                    loadingOverlayComponent={Loader}
                    noRowsOverlayComponent={() => (
                        <div className="flex items-center justify-center h-full">
                            <div className="text-center text-gray-500">
                                <div className="text-lg font-medium">No Data Found</div>
                            </div>
                        </div>
                    )}
                />
            </div>
        </div>
    );
};

export default WorkOrderHistory;